import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-bar-percent',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bar-percent.component.html',
  styleUrls: ['./bar-percent.component.scss']
})
export class BarPercentComponent {
  @Input() percent: number = 0;
  @Input() color: string = 'blue';
}
